/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsqueryRecommendationsPopularCategoriesGet$Params {
}

export function apiProductsqueryRecommendationsPopularCategoriesGet(http: HttpClient, rootUrl: string, params?: ApiProductsqueryRecommendationsPopularCategoriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryRecommendationsPopularCategoriesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: Array<SalesArticleSummary>;
      }>;
    })
  );
}

apiProductsqueryRecommendationsPopularCategoriesGet.PATH = '/api/productsquery/recommendations/popular/categories';
